const fixedContainer = document.querySelector('#fixed-container');
export const articles = Array.from(document.querySelectorAll('article'));
export const sections = Array.from(document.querySelectorAll('section'));
export const sectionToFixedMap = new Map(Array.from(sections).map(section => [section, fixedContainer.querySelector(`[data-section="${section.id}"]`)]));
export const minmax = (min, val, max) => Math.max(min, Math.min(val, max));
export const portrait = matchMedia('(max-width: 768px), (orientation: portrait)');
export const promo = document.querySelector('#promo');
export const cornflowerBlue = '#72A2C1';

TweenLite.defaultEase = Linear.easeNone;

// remove from sectionToFixedMap those sections which have no corresponding fixed element
for (const [key, value] of sectionToFixedMap) {
  if (!value) {
    sectionToFixedMap.delete(key);
  }
}

/**
 * Wait for images to load
 * @param {HTMLImageElement} image image
 * @return {Promise} resolves when image has loaded
 */
export function waitForImage(image) {
  return new Promise(resolve => {
    const done = () => {
      image.removeEventListener('load', done);
      image.removeEventListener('error', done);
      resolve();
    };

    if (image.complete) {
      resolve();
    } else {
      image.addEventListener('load', done);
      image.addEventListener('error', done);
    }
  });
}

/**
 * Wait for video to load
 * @param {HTMLElement} video video element
 * @return {Promise} resolves when video has loaded metadata
 */
export function waitForVideo(video) {
  return new Promise((resolve, reject) => {
    const done = () => {
      video.removeEventListener('loadedmetadata', done);
      video.removeEventListener('error', done);
      resolve();
    };

    if (video.readyState >= video.HAVE_METADATA) {
      return resolve();
    }

    video.addEventListener('loadedmetadata', done);
    video.addEventListener('error', done);
  });
}
